import { Button } from '@uturn/ui-kit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGroupContext } from '../../context/group-context';
import CreateGroup from './create-group';
import Group from './group';
import GroupItem from './group-item';

const Groups = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const { optimisticGroups } = useGroupContext();

	return (
		<>
			<div className="flex-1">
				<div className="flex flex-col gap-4">
					<div className="flex justify-between items-center">
						<h2 className="font-medium">{t('groups.title', 'Groups')}</h2>
						<Button onClick={() => setOpen(true)} data-usetiful="create-group-button">
							{t('groups.create-group', 'Create group')}
						</Button>
					</div>
					{optimisticGroups.length > 0 ? (
						<div className="flex-1 grid grid-cols-3 gap-5">
							{optimisticGroups.map((group) => (
								<Group key={group.groupId} group={group}>
									{group.carriers?.map((carrier) => (
										<GroupItem
											key={`${group.groupId}.${carrier.organizationId}`}
											id={`${group.groupId}.${carrier.organizationId}`}
											group={group}
											carrier={{
												id: carrier.organizationId,
												name: carrier.organizationName,
												email: carrier.email,
											}}
											isPending={carrier.isPending || false}
										/>
									))}
								</Group>
							))}
						</div>
					) : (
						<div className="flex flex-col items-center justify-center gap-4 h-[600px]">
							<div className="text-center">
								<h2 className="text-lg font-semibold">
									{t('groups.empty.title', 'You have no groups (yet)')}
								</h2>
								<h3 className="text-gray-500">
									{t(
										'groups.empty.description',
										'Create your first group using the button above',
									)}
								</h3>
							</div>
						</div>
					)}
				</div>
			</div>
			<CreateGroup open={open} setOpen={setOpen} />
		</>
	);
};

export default Groups;
